import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import Service from '../src/service/Service';
import "./App.css";
import CompanyPresentation from "./CompanyPresentation";
import image1 from "./images/image1.png";
import image2 from "./images/image2.png";
import image3 from "./images/image3.png";
import ValueProposition from "./valueProposition";
import WorldMap from "./worldmap";

const Common = (props) => {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);
  const images = [
    image1,
    image2,
    image3
  ];

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderSubtitleWithImages = (subtitle) => {
    const parts = subtitle.split("*");
    return parts.flatMap((part, index) => {
      const elements = [];
  
      // Replace "MyOutsourcing" with a <strong> element
      const highlightedText = part.split(/(MyOutsourcing)/g).map((segment, i) =>
        segment === "MyOutsourcing" ? (
          <strong key={`strong-${index}-${i}`}>{segment}</strong>
        ) : (
          <React.Fragment key={`frag-${index}-${i}`}>{segment}</React.Fragment>
        )
      );
  
      elements.push(<React.Fragment key={`text-${index}`}>{highlightedText}</React.Fragment>);
  
      // Only add image if it's not the last part
      if (index < parts.length - 1 && images[index]) {
        if (index === 1 || index === 2) {
          elements.push(<br key={`br1-${index}`} />);
          elements.push(<br key={`br2-${index}`} />);
        }
  
        elements.push(
          <img
            className="blue-color-code"
            key={`img-${index}`}
            src={images[index]}
            alt={`symbol-${index}`}
            style={{
              height: "2em",
              margin: "0 0.25em",
              verticalAlign: "middle",
            }}
          />
        );
      }
  
      return elements;
    });
  };
  


  return (
    <>
      <section id="header">
        <div className="container">
          {props.imgsrc ? (
            <>
              <div className="row align-items-center">
                <div className="col-12 col-md-6 order-2 order-md-1 d-flex flex-column justify-content-center text-center text-md-start my-4">
                  <h1 className="fs-2">
                    {props.name}
                    <br />
                    <strong className="brand-name"> MY OUTSOURCING </strong>
                  </h1>
                  <h2 className="my-3 fs-5 text-black">
                    {renderSubtitleWithImages(props.subtitle)}
                  </h2>
                </div>
                <div className="col-12 col-md-6 order-1 order-md-2 text-center mb-4">
                  <img
                    src={props.imgsrc}
                    className="img-fluid w-90"
                    alt="home"
                    style={{
                      maxHeight: "400px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
              <Service home={true} />
              <div className="row mt-5">
                <ValueProposition />
              </div>
              <div className="mt-4">
                <h3 className="text-center"> <strong>{t("map_title")}</strong> </h3>
                <WorldMap />
              </div>
            </>
          ) : (
            <>
              <div className="col-12 d-flex flex-column justify-content-center text-center text-md-start my-4">
                <h1 className="fs-2">
                  {props.name}
                  <strong className="brand-name"> MY OUTSOURCING </strong>
                </h1>
                <h2 className="my-3 fs-5">
                  {renderSubtitleWithImages(props.subtitle)}
                </h2>
                <div className="border-bottom my-3"></div>
                {props.imgsrc ? <ValueProposition /> : <CompanyPresentation />}
                <div className="my-3">
                  <NavLink to={props.visit} className="btn-get-started">
                    {props.btname}
                  </NavLink>
                </div>
              </div>
            </>
          )}
        </div>
      </section>
      {showScrollTop && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          ↑
        </button>
      )}
    </>
  );
};

export default Common;
